import { render, staticRenderFns } from "./advert-contacts-list-item.vue?vue&type=template&id=a99afabe"
import script from "./advert-contacts-list-item.vue?vue&type=script&lang=ts"
export * from "./advert-contacts-list-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports